export enum BrandType {
    Goodyear = 'Goodyear',
    NonGoodyear = 'NonGoodyear',
    Unknown = 'Unknown',
}
